import React from 'react'
import { Badge, Button, Col, Dropdown, Row, Tooltip, Typography, theme } from 'antd'
import { BellOutlined, ReloadOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRefresh, faSearch, faCog, faBell } from '@fortawesome/free-solid-svg-icons'

const { Title, Text } = Typography

const HeaderSection = ({ notifications = [], onRefresh }) => {
  const { token } = theme.useToken()

  // Button styling to match other components
  const buttonStyle = {
    height: '40px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '0 16px',
    fontWeight: 500,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease'
  }

  return (
    <Row gutter={[0, 0]} align='middle' justify='space-between' wrap>
      <Col xs={24} sm={16} md={16} lg={16} xl={16}>
        {/* Left side space for filters if needed */}
      </Col>
      <Col xs={24} sm={8} md={8} lg={8} xl={8}>
        <Row gutter={[12, 8]} justify='end'>
          <Col>
            <Tooltip title='Search'>
              <Button
                type='default'
                size='large'
                icon={<FontAwesomeIcon icon={faSearch} style={{ color: token.actionColor || token.colorPrimary }} />}
                style={{
                  ...buttonStyle,
                  background: 'rgba(24, 144, 255, 0.1)',
                  borderColor: 'rgba(24, 144, 255, 0.3)',
                  color: token.actionColor || token.colorPrimary
                }}
              />
            </Tooltip>
          </Col>
          <Col>
            <Tooltip title='Refresh'>
              <Button
                onClick={onRefresh}
                type='default'
                size='large'
                icon={
                  <FontAwesomeIcon
                    icon={faRefresh}
                    style={{
                      color: token.actionColor || token.colorPrimary,
                      animation: false ? 'spin 1s linear infinite' : 'none'
                    }}
                  />
                }
                style={{
                  ...buttonStyle,
                  background: 'rgba(24, 144, 255, 0.1)',
                  borderColor: 'rgba(24, 144, 255, 0.3)',
                  color: token.actionColor || token.colorPrimary
                }}
              >
                Refresh
              </Button>
            </Tooltip>
          </Col>
          <Col>
            <Dropdown
              menu={{
                items: notifications.map((notification) => ({
                  key: notification.id,
                  label: (
                    <div>
                      <Text strong={!notification.read}>{notification.message}</Text>
                      <div>
                        <Text type='secondary' style={{ fontSize: '12px' }}>
                          {notification.time}
                        </Text>
                      </div>
                    </div>
                  )
                })),
                style: { backgroundColor: 'white' }
              }}
              trigger={['click']}
            >
              <Badge count={notifications.filter((n) => !n.read).length}>
                <Button
                  type='default'
                  size='large'
                  icon={<FontAwesomeIcon icon={faBell} style={{ color: token.actionColor || token.colorPrimary }} />}
                  style={{
                    ...buttonStyle,
                    background: 'rgba(24, 144, 255, 0.1)',
                    borderColor: 'rgba(24, 144, 255, 0.3)',
                    color: token.actionColor || token.colorPrimary
                  }}
                />
              </Badge>
            </Dropdown>
          </Col>
          <Col>
            <Tooltip title='Settings'>
              <Button
                type='default'
                size='large'
                icon={<FontAwesomeIcon icon={faCog} style={{ color: token.actionColor || token.colorPrimary }} />}
                style={{
                  ...buttonStyle,
                  background: 'rgba(24, 144, 255, 0.1)',
                  borderColor: 'rgba(24, 144, 255, 0.3)',
                  color: token.actionColor || token.colorPrimary
                }}
              />
            </Tooltip>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default HeaderSection
